import { HttpErrorResponse } from '@angular/common/http';
import { ErrorHandler, Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { LoggerService } from '../logger/logger.service';
import { isExpiredAuth0RefreshTokenError } from 'src/app/common/errorUtils';

@Injectable()
export class GlobalErrorHandler implements ErrorHandler {
  constructor(
    private readonly _logger: LoggerService,
    private readonly _router: Router
  ) {}

  public handleError(error: Error | HttpErrorResponse) {
    if (!(error instanceof HttpErrorResponse) && !isExpiredAuth0RefreshTokenError(error)) {
      const currentUrl = this._router.url;
      this._logger.error(`Unhandled exception found on url: ${currentUrl} error: ${error}`, {}, error);
    }
  }
}
